import React from "react";
import ReduxToastr from "react-redux-toastr";

// Styles
import "./assets/scss/app.scss";
import "react-loading-skeleton/dist/skeleton.css";

// State
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import configureStore, { history } from "./state/store";

// Custom Higher Order Components
import ThemeProvider from "./themes";
import BlockUI from "./components/Security/BlockUI";

// Routing
import Routes from "./routes/Routes";

// Initialize Store
const store = configureStore(/* provide initial state if any */);

export default function App() {
  return (
    <div className="App" data-testid="app">
      <Provider store={store}>
        <BlockUI>
          <ThemeProvider>
            <ConnectedRouter history={history}>
              <Routes />

              <ReduxToastr
                timeOut={0}
                newestOnTop={true}
                position="top-right"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                progressBar
                closeOnToastrClick
              />
            </ConnectedRouter>
          </ThemeProvider>
        </BlockUI>
      </Provider>
    </div>
  );
}
